import { signInUrl } from "@abodeminehq/entitlements-client-react";
import { createFileRoute } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { LAST_ACTIVE_ORG_KEY } from "~/components/app/shared/user-org-selector";
import { clearPostHogIdentification } from "~/lib/posthog.client";
import { SIGNOUT_RETURN_KEY } from "~/contexts/auth-context";

export const Route = createFileRoute("/callback/signout")({
  component: RouteComponent,
});

function RouteComponent() {
  const posthog = usePostHog();
  const queryClient = useQueryClient();

  useEffect(() => {
    // `?signin=1`: home signs a signed-out visitor straight back in now, which
    // is right for everyone except the person who just asked to be signed out.
    let destination = signInUrl("/");

    try {
      posthog.reset();
      clearPostHogIdentification();

      localStorage.removeItem(`lastOrgId`);
      localStorage.removeItem(LAST_ACTIVE_ORG_KEY);
      sessionStorage.removeItem("activeOrgId");

      const returnTo = sessionStorage.getItem(SIGNOUT_RETURN_KEY);
      sessionStorage.removeItem(SIGNOUT_RETURN_KEY);

      if (returnTo?.startsWith("/") && !returnTo.startsWith("//")) {
        destination = returnTo;
      }

      queryClient.clear();
    } finally {
      window.location.replace(destination);
    }
  }, [posthog, queryClient]);

  return <div>Logging out...</div>;
}
